import { NotificationAPIService } from './AxiosAPIService';
import { logger } from './SharedService';
import {
  Notification, NotificationsResponse, NotificationDeleteRequest, NotificationSettings, NotificationSettingsPatch,
} from '../types/Notifications';

export const getNotifications = async (fleetId: string): Promise<NotificationsResponse> => {
  logger.info('GET', 'REQUEST', 'getNotifications', `/fleets/${fleetId}/notifications?limit=1000&skip=0`);
  const { data } = await NotificationAPIService.api.get<NotificationsResponse>(`/fleets/${fleetId}/notifications?limit=1000&skip=0`);
  logger.info('GET', 'RESPONSE', 'getNotifications', data);
  return data;
};

// read notification or all notifications (remove from db)
export const deleteNotification = async (payload: NotificationDeleteRequest): Promise<Notification> => {
  const {
    fleetId, notificationId,
  } = payload;
  logger.info('DELETE', 'REQUEST', 'deleteNotification', `/fleets/${fleetId}/notifications${notificationId ? `/${notificationId}` : ''}`, payload);
  const { data } = await NotificationAPIService.api.delete<Notification>(`/fleets/${fleetId}/notifications${notificationId ? `/${notificationId}` : ''}`)
    .catch((e) => Promise.reject(e.response.data));
  logger.info('DELETE', 'RESPONSE', 'deleteNotification', data);
  return data;
};

export const getNotificationSettings = async (fleetId: string): Promise<NotificationSettings> => {
  logger.info('GET', 'REQUEST', 'getNotificationSettings', `/fleets/${fleetId}/user-settings/user`);
  const { data } = await NotificationAPIService.api.get<NotificationSettings>(`/fleets/${fleetId}/user-settings/user`);
  logger.info('GET', 'RESPONSE', 'getNotificationSettings', data);
  return data;
};

export const patchNotificationSettings = async (payload: NotificationSettingsPatch): Promise<NotificationSettings> => {
  const { fleetId, ...settings } = payload;
  Object.entries(settings).forEach(([key, sub]) => {
    if (sub && typeof sub === 'object' && '_id' in sub) {
      delete (sub as { _id?: string })._id;
    }
  });
  logger.info('PATCH', 'REQUEST', 'patchNotificationSettings', `/fleets/${payload.fleetId}/user-settings/`, settings);
  const { data } = await NotificationAPIService.api.patch<NotificationSettings>(`/fleets/${payload.fleetId}/user-settings/`, settings)
    .catch((e) => Promise.reject(e.response.data));
  logger.info('PATCH', 'RESPONSE', 'patchNotificationSettings', data);
  return data;
};
